export function getWebinarsRoutes() {
  return [
    {
      path: "/webinars",
      name: "webinars",
      component: () => import(/* webpackChunkName: webinars-old-backend */ "./components/WebinarsOld.vue"),
    },
  ]
}
